const childrenLoaded = require('@alexspirgel/children-loaded');
import $ from 'jquery';
import 'slick-carousel';

class ComponentCarousel extends HTMLDivElement {

	constructor() {
		super();
	}
	async connectedCallback() {
		await childrenLoaded(this);
		var $captions = $(this).find('.component-carousel__slide-caption:not(.slick-cloned)');
		$(this).find('.component-carousel__slides').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			// asNavFor: '.slider-for',
			centerMode: true,
			centerPadding: '20px',
			focusOnSelect: true,
			mobileFirst: true,
			prevArrow: $('.component-carousel__slides-prev-btn'),
			nextArrow: $('.component-carousel__slides-next-btn'),
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: '60px',
					}
				},
				{
					breakpoint: 1200,
					settings: {
						centerPadding: '120px',
					}
				}
			]
		});
		$(this).append($captions);
		showCaption(0, $captions);
		$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$('.component-carousel__slides-counter-current').text(nextSlide + 1);
			showCaption(nextSlide, $captions);
		});
	}

}

function showCaption(targetIndex, $captions) {
	$captions.each(function (index) {
		if (targetIndex == index) {
			$(this).delay(100).show();
			$(this).find('p').delay(200).animate({ opacity: 1 }, 50);
		} else {
			$(this).find('p').animate({ opacity: 0 }, 50);
			$(this).delay(50).hide();
		}
	});
}

customElements.define('component-carousel', ComponentCarousel, {extends: 'div'});